import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { canUseDOM, loadTreatment, getUserPremiumStatus } from '@surfline/web-common';
import { NotFound, FiveHundred } from '@surfline/quiver-react';
import { getStatusCode } from '../../selectors/status';

class KBYGPageContainer extends Component {
  constructor(props) {
    super(props);
    const {
      flags: {
        identity: { type, userId },
      },
    } = props;
    if (canUseDOM && window.analytics && window.analytics.user) {
      if (type === 'logged_in') {
        window.analytics.identify(userId, { sourceOrigin: 'KBYG' });
      }
    }
  }

  componentDidMount() {
    const { doLoadTreatments } = this.props;
    /**
     * These treatements are temporary and used to
     * validate the Split/Segment metrics within this app.
     */
    doLoadTreatments('kbyg_only_test');
    doLoadTreatments('cross_app_only_test');
  }

  getClassName = () => {
    const { isPremium } = this.props;

    return classNames({
      'sl-kbyg-page-container': true,
      'sl-kbyg-page-container--is-premium': isPremium,
    });
  };

  pageContent = () => {
    const { status, children } = this.props;
    if (status === 404) {
      return <NotFound />;
    }
    if (status === 500) {
      return <FiveHundred />;
    }
    return children;
  };

  render() {
    return (
      <div>
        <div className={this.getClassName()}>{this.pageContent()}</div>
        <div id="modal-root" />
      </div>
    );
  }
}

KBYGPageContainer.propTypes = {
  children: PropTypes.node,
  status: PropTypes.number.isRequired,
  isPremium: PropTypes.bool.isRequired,
  flags: PropTypes.shape({
    identity: PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      userId: PropTypes.string,
    }),
  }).isRequired,
  doLoadTreatments: PropTypes.func.isRequired,
};

KBYGPageContainer.defaultProps = {
  children: null,
};

export default connect(
  (state) => ({
    status: getStatusCode(state),
    isPremium: getUserPremiumStatus(state),
    flags: state.flags,
  }),
  (dispatch) => ({
    doLoadTreatments: (treatment) => dispatch(loadTreatment(treatment)),
  }),
)(KBYGPageContainer);
